import axios from 'axios';

/**
 * True when a bulk premium call failed because it was aborted (replaced by a newer request or navigation).
 * Not a user-actionable error - a later fetch may succeed.
 */
export function isSupersededPremiumRequestError(reason) {
  if (reason == null) return false;
  if (typeof axios.isCancel === 'function' && axios.isCancel(reason)) return true;
  if (reason.code === 'ERR_CANCELED') return true;
  if (reason.name === 'CanceledError' || reason.name === 'AbortError') return true;
  const msg =
    typeof reason.message === 'string' ? reason.message.trim().toLowerCase() : '';
  return (
    msg === 'canceled' ||
    msg === 'cancelled' ||
    msg.includes('request aborted') ||
    msg.includes('the user aborted')
  );
}
